
import { MembershipPlansSection } from './components/MembershipPlansSection';
import { DropInPassesSection } from './components/DropInPassesSection';
import { EventsSection } from './components/EventsSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function MembershipPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <MembershipPlansSection />
      <DropInPassesSection />
      <EventsSection />
      <Footer />
    </div>
  );
}
